export const financialEducation = {
  // Main section
  financialEducation: 'Educación Financiera',
  financialEducationDesc: 'Aprende sobre finanzas personales de manera interactiva y divertida',
  
  // Additional translations
  level: 'Nivel',
  keepGoing: 'Sigue así',
  startLearning: 'Empezar a Aprender',
  playAndLearn: 'Juega y aprende',
  searchFinancialTerms: 'Busca términos financieros',
  learnByPlaying: 'Aprende jugando',
  structuredLearning: 'Aprendizaje estructurado',
  practicalCalculators: 'Calculadoras prácticas',
  dailyWeeklyChallenges: 'Desafíos diarios y semanales',
  compareWithOthers: 'Compárate con otros',
  viewRankings: 'Ver clasificación',
  viewChallenges: 'Ver desafíos',
  explore: 'Explorar',
  play: 'Jugar',
  recentActivity: 'Actividad Reciente',
  yourLearningJourney: 'Tu viaje de aprendizaje',
  noActivityYet: 'Aún no hay actividad',
  financialDictionary: 'Diccionario Financiero',
  dictionaryComingSoon: 'El diccionario estará disponible pronto con cientos de términos',
  financialGames: 'Juegos Financieros',
  gamesComingSoon: 'Los juegos educativos estarán disponibles pronto',
  financialCourses: 'Cursos Financieros',
  coursesComingSoon: 'Los cursos estructurados estarán disponibles pronto',
  financialSimulators: 'Simuladores Financieros',
  simulatorsComingSoon: 'Las calculadoras y simuladores estarán disponibles pronto',
  financialChallenges: 'Desafíos Financieros',
  challengesComingSoon: 'Los desafíos diarios y semanales estarán disponibles pronto',
  leaderboardComingSoon: 'La tabla de líderes estará disponible pronto',
  
  // Navigation
  dashboard: 'Panel',
  dictionary: 'Diccionario',
  games: 'Juegos',
  courses: 'Cursos',
  simulators: 'Simuladores',
  challenges: 'Desafíos',
  leaderboard: 'Tabla de Líderes',
  myProgress: 'Mi Progreso',
  
  // Dashboard
  welcomeBack: 'Bienvenido de nuevo',
  yourProgress: 'Tu Progreso',
  totalPoints: 'Puntos Totales',
  currentStreak: 'Racha Actual',
  coursesCompleted: 'Cursos Completados',
  gamesPlayed: 'Juegos Jugados',
  currentLevel: 'Nivel Actual',
  experiencePoints: 'Puntos de Experiencia',
  daysStreak: '{count} días',
  
  // Dictionary
  searchTerms: 'Buscar términos...',
  allCategories: 'Todas las Categorías',
  allDifficulties: 'Todas las Dificultades',
  favorites: 'Favoritos',
  mostViewed: 'Más Vistos',
  recentlyAdded: 'Añadidos Recientemente',
  allTerms: 'Todos los Términos',
  selectTermToView: 'Selecciona un término para ver detalles',
  views: 'vistas',
  
  
  // Dictionary categories
  budgeting: 'Presupuestos',
  investment: 'Inversión',
  investing: 'Inversión',
  debt: 'Deudas',
  saving: 'Ahorro',
  savings: 'Ahorro',
  retirement: 'Retiro',
  taxes: 'Impuestos',
  'real-estate': 'Bienes Raíces',
  general: 'General',
  
  // Dictionary difficulties
  basic: 'Básico',
  intermediate: 'Intermedio',
  advanced: 'Avanzado',
  
  // Term details
  definition: 'Definición',
  example: 'Ejemplo',
  relatedTerms: 'Términos Relacionados',
  addToFavorites: 'Añadir a Favoritos',
  removeFromFavorites: 'Quitar de Favoritos',
  share: 'Compartir',
  
  // Quiz
  quiz: 'Quiz',
  quickQuiz: 'Quiz Rápido',
  dailyTrivia: 'Trivia Diaria',
  categoryQuiz: 'Quiz por Categoría',
  startQuiz: 'Iniciar Quiz',
  selectCategory: 'Seleccionar Categoría',
  selectDifficulty: 'Seleccionar Dificultad',
  question: 'Pregunta',
  of: 'de',
  timeRemaining: 'Tiempo Restante',
  submit: 'Enviar',
  nextQuestion: 'Siguiente Pregunta',
  finishQuiz: 'Finalizar Quiz',
  
  // Quiz difficulties
  easy: 'Fácil',
  medium: 'Medio',
  hard: 'Difícil',
  
  // Quiz results
  quizComplete: '¡Quiz Completado!',
  yourScore: 'Tu Puntuación',
  correctAnswers: 'Respuestas Correctas',
  pointsEarned: 'Puntos Ganados',
  viewExplanations: 'Ver Explicaciones',
  tryAgain: 'Intentar de Nuevo',
  shareResults: 'Compartir Resultados',
  
  // Games
  budgetChallenge: 'Desafío del Presupuesto',
  budgetChallengeDesc: 'Gestiona un presupuesto mensual y enfrenta eventos inesperados',
  debtDestroyer: 'Destructor de Deudas',
  debtDestroyerDesc: 'Aprende estrategias para eliminar deudas de manera efectiva',
  investmentTycoon: 'Magnate de Inversiones',
  investmentTycoonDesc: 'Invierte en diferentes activos y maximiza tus ganancias',
  financialScenarios: 'Escenarios Financieros',
  financialScenariosDesc: 'Toma decisiones en situaciones financieras del mundo real',
  
  // Game interface
  startGame: 'Iniciar Juego',
  selectDifficultyLevel: 'Seleccionar Nivel de Dificultad',
  currentBalance: 'Balance Actual',
  month: 'Mes',
  score: 'Puntuación',
  makeDecision: 'Tomar Decisión',
  continue: 'Continuar',
  gameOver: 'Juego Terminado',
  finalScore: 'Puntuación Final',
  playAgain: 'Jugar de Nuevo',
  
  // Courses
  availableCourses: 'Cursos Disponibles',
  myCourses: 'Mis Cursos',
  courseProgress: 'Progreso del Curso',
  startCourse: 'Iniciar Curso',
  continueCourse: 'Continuar Curso',
  lessons: 'Lecciones',
  estimatedTime: 'Tiempo Estimado',
  hours: 'horas',
  minutes: 'minutos',
  
  // Course categories
  basics: 'Fundamentos',
  planning: 'Planificación',
  
  // Course difficulties
  beginner: 'Principiante',
  
  // Lesson interface
  lessonContent: 'Contenido de la Lección',
  previousLesson: 'Lección Anterior',
  nextLesson: 'Siguiente Lección',
  completeLesson: 'Completar Lección',
  lessonCompleted: '¡Lección Completada!',
  watchVideo: 'Ver Video',
  takeQuiz: 'Hacer Quiz',
  
  // Simulators
  compoundInterestCalculator: 'Calculadora de Interés Compuesto',
  compoundInterestDesc: 'Calcula el crecimiento de tus inversiones con interés compuesto',
  stockInvestmentSimulator: 'Simulador de Inversión en Acciones',
  stockInvestmentDesc: 'Simula inversiones en el mercado de valores',
  debtPaymentPlanner: 'Planificador de Pago de Deudas',
  debtPaymentDesc: 'Compara estrategias para pagar tus deudas',
  retirementCalculator: 'Calculadora de Jubilación',
  retirementDesc: 'Planifica tus ahorros para la jubilación',
  
  // Simulator interface
  inputs: 'Datos de Entrada',
  results: 'Resultados',
  calculate: 'Calcular',
  saveResults: 'Guardar Resultados',
  resetCalculator: 'Reiniciar Calculadora',
  initialAmount: 'Monto Inicial',
  monthlyContribution: 'Contribución Mensual',
  interestRate: 'Tasa de Interés',
  timeYears: 'Tiempo (años)',
  finalAmount: 'Monto Final',
  totalContributions: 'Contribuciones Totales',
  totalInterestEarned: 'Intereses Ganados',
  
  // Challenges
  activeChallenges: 'Desafíos Activos',
  completedChallenges: 'Desafíos Completados',
  dailyChallenge: 'Desafío Diario',
  weeklyChallenge: 'Desafío Semanal',
  monthlyChallenge: 'Desafío Mensual',
  challengeProgress: 'Progreso del Desafío',
  daysRemaining: 'Días Restantes',
  startChallenge: 'Iniciar Desafío',
  challengeCompleted: '¡Desafío Completado!',
  claimReward: 'Reclamar Recompensa',
  
  // Achievements
  achievements: 'Logros',
  unlockedAchievements: 'Logros Desbloqueados',
  lockedAchievements: 'Logros Bloqueados',
  recentAchievements: 'Logros Recientes',
  
  // Achievement categories
  quizAchievements: 'Logros de Quiz',
  courseAchievements: 'Logros de Cursos',
  gameAchievements: 'Logros de Juegos',
  streakAchievements: 'Logros de Racha',
  masteryAchievements: 'Logros de Maestría',
  
  // Achievement rarities
  common: 'Común',
  rare: 'Raro',
  epic: 'Épico',
  legendary: 'Legendario',
  
  // Leaderboard
  globalLeaderboard: 'Tabla Global',
  weeklyLeaderboard: 'Tabla Semanal',
  monthlyLeaderboard: 'Tabla Mensual',
  rank: 'Rango',
  player: 'Jugador',
  points: 'Puntos',
  coursesComplete: 'Cursos',
  gamesWon: 'Juegos Ganados',
  currentStreakDays: 'Racha',
  myRank: 'Mi Rango',
  
  // Progress stats
  statistics: 'Estadísticas',
  overallProgress: 'Progreso General',
  quizStats: 'Estadísticas de Quiz',
  courseStats: 'Estadísticas de Cursos',
  gameStats: 'Estadísticas de Juegos',
  totalQuizzesTaken: 'Quizzes Realizados',
  averageQuizScore: 'Puntuación Promedio',
  lessonsCompleted: 'Lecciones Completadas',
  totalTimeSpent: 'Tiempo Total',
  gamesCompleted: 'Juegos Completados',
  averageGameScore: 'Puntuación Promedia de Juegos',
  
  // Common actions
  start: 'Iniciar',
  complete: 'Completar',
  view: 'Ver',
  edit: 'Editar',
  delete: 'Eliminar',
  save: 'Guardar',
  cancel: 'Cancelar',
  back: 'Volver',
  next: 'Siguiente',
  previous: 'Anterior',
  close: 'Cerrar',
  review: 'Repasar',
  readingProgress: 'Progreso de Lectura',
  
  // Status messages
  loading: 'Cargando...',
  savingStatus: 'Guardando...',
  success: 'Éxito',
  error: 'Error',
  noResultsFound: 'No se encontraron resultados',
  comingSoon: 'Próximamente',
  
  // Notifications
  termAddedToFavorites: 'Término añadido a favoritos',
  termRemovedFromFavorites: 'Término eliminado de favoritos',
  quizResultsSaved: 'Resultados del quiz guardados',
  lessonProgressSaved: 'Progreso de la lección guardado',
  lessonCompletedSuccess: '¡Lección completada exitosamente!',
  courseCompletedSuccess: '¡Curso completado exitosamente!',
  gameResultsSaved: 'Resultados del juego guardados',
  simulatorResultsSaved: 'Resultados del simulador guardados',
  challengeProgressUpdated: 'Progreso del desafío actualizado',
  achievementUnlocked: '¡Logro desbloqueado!',
  
  // Empty states
  noFavoriteTerms: 'No tienes términos favoritos',
  noQuizResults: 'Aún no has completado ningún quiz',
  noCourses: 'No hay cursos disponibles',
  noActiveChallenges: 'No hay desafíos activos',
  noAchievements: 'Aún no has desbloqueado logros',
  
  // Tips and hints
  tip: 'Consejo',
  hint: 'Pista',
  didYouKnow: '¿Sabías que...?',
  
  // Game-specific terms
  event: 'Evento',
  decision: 'Decisión',
  impact: 'Impacto',
  strategy: 'Estrategia',
  outcome: 'Resultado',
  
  // Time-related
  seconds: 'segundos',
  day: 'día',
  days: 'días',
  week: 'semana',
  weeks: 'semanas',
  months: 'meses',
  year: 'año',
  years: 'años',
};
